import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,[_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon,_vm._g({attrs:{"small":"","color":"orange "},on:{"click":function($event){return _vm.copyTextToClipboard(_vm.link)}}},on),[_vm._v("file_copy")])]}}])},[_c('span',[_vm._v(_vm._s('Haga click para copiar')+" ")])]),_vm._v("\n\n    Se generó Link de Carga Rápida: "+_vm._s(this.link)+"\n    \n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }